import { X } from 'lucide-react';
import type { Toast as ToastType } from '../types';

const bgMap = {
  success: 'bg-success/20 border-success/50',
  error: 'bg-danger/20 border-danger/50',
  info: 'bg-info/20 border-info/50',
};

export function ToastContainer({
  toasts,
  onRemove,
}: {
  toasts: ToastType[];
  onRemove: (id: string) => void;
}) {
  if (toasts.length === 0) return null;
  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`flex items-center gap-3 px-4 py-3 rounded-xl border text-sm text-text-main ${bgMap[toast.type]} animate-[slideIn_0.3s_ease-out]`}
        >
          <span className="flex-1">{toast.message}</span>
          {toast.action && (
            <button
              onClick={() => {
                try {
                  toast.action!.onAction();
                } finally {
                  onRemove(toast.id);
                }
              }}
              className="px-2 py-1 rounded-md bg-bg-elevated/60 border border-slate-700 text-text-main text-[12px] hover:bg-bg-elevated"
            >
              {toast.action.label}
            </button>
          )}
          <button onClick={() => onRemove(toast.id)} className="text-text-muted hover:text-text-main">
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
